import { render, staticRenderFns } from "./MultiversalDimensionsTab.vue?vue&type=template&id=6f3b1cd1&"
import script from "./MultiversalDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./MultiversalDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports